import * as React from "react";
import { useState, useMemo, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import {
	Typography,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	CircularProgress,
	Alert,
} from "@mui/material";
// IoMailOpenOutline is not used, can be removed

// **MODIFIED IMPORT**
import RtPrice from "../RtPrice"; // Assuming RtPrice is a named export

import useAxiosPrivate from "../../../../../hooks/useAxiosPrivate";
import useAuth from "../../../../../hooks/useAuth";
import useRealTimePrice from "../../../../../hooks/useRealTimePrice";
import axios from "../../../../../api/axios";

// Define your actual API endpoint for Market Sell orders
// const MARKET_SELL_ORDER_API_URL = "/sell-market-order"; // Example endpoint for market sell
// const DEMO_MARKET_SELL_ORDER_API_URL = "/sell-market-order";
// const CRYPTO_BALANCE_ENDPOINT = "/get-crypto-balance";
// const DEMO_CRYPTO_BALANCE_ENDPOINT = "/get-crypto-balance";

const TradeForm = React.memo((props) => {
	const { coinPrice, coinSymbol } = props;

	// console.log(coinSymbol);

	// State management
	// **MODIFIED STATE**
	const [quantityToSell, setQuantityToSell] = useState(""); // Use quantity to sell
	const [takeProfitPrice, setTakeProfitPrice] = useState("");
	const [stopLossPrice, setStopLossPrice] = useState("");
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogMessage, setDialogMessage] = useState("");
	const [dialogType, setDialogType] = useState("success");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [cryptoBalance, setUserCryptoBalance] = useState();
	const [sellTakeProfit, setSellTakeprofit] = useState();
	const [sellStopLoss, setSellStopLoss] = useState();
	const [hasSubmitted, setHasSubmitted] = useState(false); // Track submission

	const realTimePrice = useRealTimePrice(coinSymbol);

	const axiosPrivate = useAxiosPrivate();
	const { auth, accountMode } = useAuth();

	const MARKET_SELL_ORDER_API_URL = "/sell-market-order"; // Example endpoint for market sell
	const DEMO_MARKET_SELL_ORDER_API_URL = "/demo-sell-market-order";
	const CRYPTO_BALANCE_ENDPOINT = `/get-crypto-balance/${auth?.id}/${coinSymbol}`;
	const DEMO_CRYPTO_BALANCE_ENDPOINT = `/get-demo-crypto-balance/${auth?.id}/${coinSymbol}`;

	const activeSellEndPoint =
		accountMode === "real"
			? MARKET_SELL_ORDER_API_URL
			: DEMO_MARKET_SELL_ORDER_API_URL;
	const activeCryptoBalance =
		accountMode === "real"
			? CRYPTO_BALANCE_ENDPOINT
			: DEMO_CRYPTO_BALANCE_ENDPOINT;

	useEffect(() => {
		const fetchCryptoBalance = async () => {
			try {
				const balanceRes = await axios(activeCryptoBalance);

				if (balanceRes.status === 200) {
					const { userCryptoTotalBalance, takeProfitStoploss } =
						balanceRes?.data;
					console.log(balanceRes?.data?.userCryptoTotalBalance);
					console.log(balanceRes?.data?.userCryptoTotalBalance);
					console.log(balanceRes?.data?.userCryptoTotalBalance);
					setUserCryptoBalance(balanceRes?.data?.userCryptoTotalBalance);
					setSellStopLoss(balanceRes?.data?.totalStopLoss);
					setSellTakeprofit(balanceRes?.data?.totalTakeProfit);
				}
			} catch (error) {
				console.log(error);
			}
		};

		fetchCryptoBalance();

		return () => {};
	}, []);

	const loadingUi = <span className="animate-pulse  text-gray">00.00</span>;

	const userCoinBalance =
		typeof cryptoBalance === "undefined" ? loadingUi : cryptoBalance;

	console.log(cryptoBalance);

	// **NEW: Get user's crypto balance for the specific coin**
	// Assuming auth.cryptoBalances is an object like { BTC: 0.5, ETH: 2.1, ... }
	const userCryptoBalance = useMemo(() => {
		return auth?.cryptoBalances?.[coinSymbol] || 0;
	}, [auth, coinSymbol]);

	const accountBalance =
		typeof auth?.balance === "undefined" ? "loading..." : `$${auth?.balance}`;

	// **REMOVED: Approximate calculation based on USD amount is not applicable for selling quantity**
	// const approximateCryptoAmount = useMemo(() => {
	//   // ... (previous logic)
	// }, [usdAmount, coinPrice]);

	// Handlers
	// **NEW HANDLER**
	const handleQuantityToSellChange = (e) => {
		const value = e.target.value;
		if (/^\d*\.?\d*$/.test(value) || value === "") {
			setQuantityToSell(value);
		}
	};
	const handleTakeProfitPriceChange = (e) => {
		const value = e.target.value;
		if (/^\d*\.?\d*$/.test(value) || value === "") {
			setTakeProfitPrice(value);
		}
	};
	const handleStopLossPriceChange = (e) => {
		const value = e.target.value;
		if (/^\d*\.?\d*$/.test(value) || value === "") {
			setStopLossPrice(value);
		}
	};

	const handleCloseDialog = () => setDialogOpen(false);

	const handleSubmit = async () => {
		if (hasSubmitted) return; // prevent further submits if already submitted
		setError("");
		setHasSubmitted(true); // mark as submitted

		// **MODIFIED PARSING**
		const parsedQuantityToSell = parseFloat(quantityToSell);
		// const parsedTPPrice = parseFloat(takeProfitPrice);
		// const parsedSLPrice = parseFloat(stopLossPrice);
		const currentPrice = parseFloat(coinPrice);

		// **MODIFIED VALIDATION**
		// if (isNaN(parsedQuantityToSell) || parsedQuantityToSell <= 0) {
		// 	setError(
		// 		`Please enter a valid positive quantity of ${coinSymbol} to sell.`
		// 	);
		// 	return;
		// }

		// **NEW VALIDATION: Check if user has enough crypto**
		// if (parsedQuantityToSell > userCryptoBalance) {
		// 	setError(
		// 		`You do not have enough ${coinSymbol} to sell this quantity. Your balance is ${userCryptoBalance} ${coinSymbol}.`
		// 	);
		// 	return;
		// }

		// if (
		// 	takeProfitPrice !== "" &&
		// 	(isNaN(parsedTPPrice) || parsedTPPrice <= 0)
		// ) {
		// 	setError("Please enter a valid positive Take Profit price.");
		// 	return;
		// }

		// **MODIFIED VALIDATION FOR TP (Sell Order)**
		// if (
		// 	takeProfitPrice !== "" &&
		// 	currentPrice &&
		// 	parsedTPPrice >= currentPrice
		// ) {
		// 	setError(
		// 		"Take Profit price must be lower than the current market price for a Sell order."
		// 	);
		// 	return;
		// }

		// if (stopLossPrice !== "" && (isNaN(parsedSLPrice) || parsedSLPrice <= 0)) {
		// 	setError("Please enter a valid positive Stop Loss price.");
		// 	return;
		// }

		// **MODIFIED VALIDATION FOR SL (Sell Order)**
		// if (stopLossPrice !== "" && currentPrice && parsedSLPrice <= currentPrice) {
		// 	setError(
		// 		"Stop Loss price must be higher than the current market price for a Sell order."
		// 	);
		// 	return;
		// }

		// **MODIFIED ORDER DATA**
		const orderData = {
			id: auth?.id,
			coinSymbol: coinSymbol,
			orderType: "sell", // Set order type to market_sell
			quantity: userCoinBalance, // Include quantity to sell
			takeProfitPrice: sellTakeProfit,
			stopLossPrice: sellStopLoss,
			marketPrice: currentPrice, // Still useful to send the current market price
		};

		console.log(orderData);

		setLoading(true);
		setError("");
		try {
			// **MODIFIED API ENDPOINT**
			const response = await axiosPrivate.patch(activeSellEndPoint, orderData);
			if (response.status === 200 || response.status === 201) {
				const executedTrade = response.data; // The response might contain details of the executed trade
				setDialogMessage(
					`Market Sell Order for ${coinSymbol} executed successfully! Your balance has been updated.`
				);
				setDialogType("success");
				setQuantityToSell(""); // Clear quantity
				setTakeProfitPrice("");
				setStopLossPrice("");
				// You might want to trigger a refetch of user balances here if your auth hook doesn't do it automatically
			} else {
				setDialogMessage(response.data?.message || "Failed to submit trade");
				setDialogType("error");
			}
		} catch (error) {
			console.error("Trade submission error:", error);
			if (error.response) {
				setDialogMessage(
					error.response.data?.message || `Error: ${error.response.status}`
				);
				setDialogType("error");
			} else if (error.request) {
				setDialogMessage("Network Error: No response from server.");
				setDialogType("error");
			} else {
				setDialogMessage("Error: " + error.message);
				setDialogType("error");
			}
		} finally {
			setLoading(false);
			setDialogOpen(true);
		}
	};

	console.log(sellStopLoss);
	console.log(sellTakeProfit);
	console.log(cryptoBalance);

	return (
		<Stack spacing={3} sx={{ width: "100%" }}>
			<RtPrice sym={coinSymbol} />
			{/* <Typography sx={{ fontSize: "1.2rem", color: "gray" }}>
				Wallet Balance: <span className="text-black">{accountBalance}</span>
			</Typography> */}
			{/* **NEW: Display user's crypto balance** */}
			<Typography sx={{ fontSize: "1.2rem", color: "gray" }}>
				Your {coinSymbol} Balance:{" "}
				<span className="text-black">{userCoinBalance}</span>
			</Typography>
			<TextField
				label="Current Asset Price" // Updated label
				type="number"
				value={
					typeof coinPrice === "object" || !coinPrice
						? Number("00.00")
						: parseFloat(coinPrice).toFixed(8)
				}
				InputProps={{ readOnly: true }}
				sx={{ width: "100%", bgcolor: "lightgray", color: "white" }}
				helperText={`Current market price for ${coinSymbol}`} // Updated helper text
				variant="filled"
			/>

			{/* **MODIFIED INPUT FOR QUANTITY TO SELL** */}
			{/* <Typography sx={{ fontSize: "0.9rem", color: "gray" }}>
				The quantity of {coinSymbol} that would be traded.
			</Typography> */}
			<TextField
				label={`Quantity of ${coinSymbol} to Sell`}
				type="text"
				InputProps={{ readOnly: true }}
				value={
					typeof userCoinBalance === "object"
						? Number("00.00")
						: userCoinBalance
				}
				onChange={handleQuantityToSellChange}
				sx={{ width: "100%" }}
				inputProps={{ step: 0.00000001, min: 0 }} // Allow for small quantities
				helperText={`You will sell ${userCoinBalance} ${coinSymbol}`}
			/>

			<Typography sx={{ fontSize: "0.9rem", color: "gray" }}>
				<span className="text-green-500 font-thin underline underline-offset-2  tracking-wide">
					Take Profit Price:
				</span>{" "}
				The target price for taking profit. {"("}Must be lower than the current
				price.{")"}
			</Typography>
			<TextField
				label=""
				type="text"
				InputProps={{ readOnly: true }}
				value={
					typeof sellTakeProfit === "object" || !sellTakeProfit
						? Number("00.00")
						: sellTakeProfit
				}
				onChange={handleTakeProfitPriceChange}
				sx={{ width: "100%" }}
				inputProps={{ step: 0.0001, min: 0 }}
			/>

			<Typography sx={{ fontSize: "0.9rem", color: "gray" }}>
				<span className="text-red-500  font-thin underline underline-offset-2  tracking-wide">
					Stop Loss Price:
				</span>{" "}
				The target price for stop loss. {"("}Must be higher than the current
				price.{")"}
			</Typography>
			<TextField
				label=""
				type="text"
				InputProps={{ readOnly: true }}
				value={
					typeof sellStopLoss === "object" || !sellStopLoss
						? Number("00.00")
						: sellStopLoss
				}
				onChange={handleStopLossPriceChange}
				sx={{ width: "100%" }}
				inputProps={{ step: 0.0001, min: 0 }}
			/>

			{error && (
				<Alert severity="error" sx={{ mt: 2 }}>
					{error}
				</Alert>
			)}

			<Button
				variant="contained"
				onClick={handleSubmit}
				disabled={
					loading ||
					!coinPrice ||
					hasSubmitted ||
					!userCoinBalance ||
					!sellStopLoss ||
					sellStopLoss === 0 ||
					!sellTakeProfit ||
					sellTakeProfit === 0
				} // Disable if no coin price or no crypto balance
				sx={{
					width: "12rem", // Adjusted width
					p: "0.5rem",
					bgcolor: "red", // Use red for sell button
					color: "white",
					mx: "auto",
					"&:hover": { bgcolor: "darkred" },
				}}>
				{loading ? <CircularProgress size={24} color="inherit" /> : "Sell"}{" "}
				{/* Updated Button Text */}
			</Button>

			<Dialog open={dialogOpen} onClose={handleCloseDialog}>
				<DialogTitle>
					{dialogType === "success" ? "Success" : "Error"}
				</DialogTitle>
				<DialogContent>
					<Typography>{dialogMessage}</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseDialog}>Close</Button>
				</DialogActions>
			</Dialog>
		</Stack>
	);
});

export default TradeForm;
